import { render, staticRenderFns } from "./IntegralStore.vue?vue&type=template&id=49d2fb9e&scoped=true&"
import script from "./IntegralStore.vue?vue&type=script&lang=js&"
export * from "./IntegralStore.vue?vue&type=script&lang=js&"
import style0 from "./IntegralStore.vue?vue&type=style&index=0&id=49d2fb9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2fb9e",
  null
  
)

export default component.exports